module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/yNcIoH/tc-custom/9781035817337.jpg?1718182737702",
      "alt": "This image is the cover for the book Hood 2 Good"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hood 2 Good\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Hood 2 Good is a fictional but inspirational story about resilience, loyalty, survival, and encouragement. Unfortunately, life is harder and more challenging for some. The people in this story were exposed to dangerous, dire situations early in their lives because they grew up in a downtrodden area of the city. A Good Samaritan who was determined to live a better life never wavered from this goal. One day the Good Samaritan rescued two little girls from a horrendous situation. From that point on the Good Samaritan dedicated his life to making sure the girls grew up in a safe, clean comfortable home with peace of mind so they could elevate in life. This story has drama, violence, humor, and adult situations.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Preston Nelson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Preston has a bachelor’s degree in Criminal Justice from the University of Houston-Downtown. He also has a patent on shoulder weights he designed in the 1980s. He is a father and a grandfather and about to start traveling internationally.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0